import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { ConfirmDialog } from '../../../../common/views/modals/confirmDialog/ConfirmDialog';
import { songPageMessages } from '../../../../smartLinks/catalog/song/page/songPageMessages';
import { themeMessages } from './themeMessages';

interface ThemeLeaveDialogProps {
  isOpen: boolean;
  title: string;
  onLeave: () => void;
  onStay: () => void;
}

/**
 * "Leave without saving the theme?" of the Releases song page: the Theme panel holds a draft that
 * is not saved. Leave drops it; "Keep editing" stays, so the user can Save or Cancel in the panel.
 */
const ThemeLeaveDialogComponent: React.FC<ThemeLeaveDialogProps> = ({ isOpen, title, onLeave, onStay }) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="danger"
      title={intl.formatMessage(themeMessages.leaveTitle)}
      description={intl.formatMessage(themeMessages.leaveBody, { title })}
      confirmLabel={intl.formatMessage(songPageMessages.leave)}
      cancelLabel={intl.formatMessage(songPageMessages.keepEditing)}
      onConfirm={onLeave}
      onCancel={onStay}
      testId="theme-leave-dialog"
    />
  );
};

export const ThemeLeaveDialog = TypedMemo(ThemeLeaveDialogComponent);
